export default __webpack_public_path__ + "static/media/Footer-Image.980eede3.jpg";